export default {

	getLessonNavIsVisible: (state) => {
		return state.lessonNavIsVisible;
	}

};
